// Nexi Logo
import nexiLogo from 'Assets/nexi/nexi_logo.svg'
import nexiLogoWhite from 'Assets/nexi/nexi_white.svg'

// UCI logo
import uciLogo from 'Assets/uci/uci_logo.svg'
import uciLogoWhite from 'Assets/uci/uci_logo_white.svg'
import uciLogoInverted from 'Assets/uci/uci_logo_inverted.svg'

export const bankServiceMapping = {
  NEXI: {
    title: 'nexi',
    logo: {
      default: nexiLogo,
      white: nexiLogoWhite,
    },
  },
  UCI: {
    title: 'uci',
    logo: {
      default: uciLogo,
      white: uciLogoWhite,
      inverted: uciLogoInverted,
    },
  },
}